"use strict";

define('view/legacy.upload',['require','exports','module','underscore','marionette','backbone','uikit/uikit','../templates','langs'],function (require, exports, module) {
  var _ = require('underscore');
  var Mn = require('marionette');
  var Backbone = require('backbone');
  var UIKit = require('uikit/uikit');
  var Templates = require('../templates');
  var langs = require('langs');
  var LEGACY_ROOT_URI = '/rs/api/form/study/legacy';
  var ResultsCard = UIKit.Container.extend({
    className: 'ui segments',
    initialize: function initialize() {
      var isOpenOnRender = this.model.get('open');
      UIKit.Container.prototype.initialize.apply(this, arguments);
      var header = new UIKit.Container({
        className: 'ui compact segment',
        attributes: {
          id: this.model.get('contentViewID') + '_header',
          'aria-controls': this.model.get('contentViewID')
        }
      });
      var btn = new UIKit.Button({
        floated: 'right',
        icon: isOpenOnRender ? 'chevron down' : 'chevron right',
        basicText: true,
        ariaLabel: this._getButtonARIALabelText(),
        attributes: {
          id: this.model.get('contentViewID') + '_button',
          'aria-expanded': isOpenOnRender
        }
      });
      header.add(btn);
      header.add(new UIKit.Text({
        className: 'ui tiny header',
        text: this.model.get('header'),
        attributes: {
          role: 'heading',
          'aria-level': '3'
        }
      }));
      var content = new UIKit.Container({
        className: 'ui fitted segment',
        visible: !!isOpenOnRender,
        attributes: {
          id: this.model.get('contentViewID'),
          role: 'region',
          'aria-labelledby': this.model.get('contentViewID') + '_header'
        }
      });
      if (!isOpenOnRender) {
        content.updateElementAttributes({
          'aria-hidden': 'true'
        });
      }
      var table = new UIKit.Table({
        headless: true,
        sortable: false,
        selectable: false,
        borderless: true,
        basic: true,
        columns: [{
          data: 'error'
        }],
        collection: this.model.get('collection')
      });
      content.add(table);
      this.add(header);
      this.add(content);
      this.listenTo(btn, 'press', function () {
        this.model.set({
          open: !this.model.get('open')
        });
        if (content.visible) {
          btn.icon = 'chevron right';
          content.hide({
            animation: 'slide down'
          });
          content.updateElementAttributes({
            'aria-hidden': 'true'
          });
        } else {
          btn.icon = 'chevron down';
          content.show({
            animation: 'slide down'
          });
          content.removeElementAttribute('aria-hidden');
        }
        btn.ariaLabel = this._getButtonARIALabelText();
        btn.updateElementAttributes({
          'aria-expanded': this.model.get('open')
        });
      });
    },
    _getButtonARIALabelText: function _getButtonARIALabelText() {
      var ariaTextPrefix = this.model.get('open') ? langs.phrase('LegacyUpload.ResultsCard.Button.Hide.Prefix') : langs.phrase('LegacyUpload.ResultsCard.Button.Show.Prefix');
      return ariaTextPrefix + this.model.get('ariaTextSuffix');
    }
  });
  var LegacyUploadView = Mn.ItemView.extend(UIKit.ComponentMixin).extend({
    template: Templates.IRB['legacy.upload'],
    useInjector: true,
    options: {
      app: null,
      pageTitle: ''
    },
    initialize: function initialize() {
      UIKit.ComponentMixin.initialize.apply(this, arguments);
      this.setupSteps();
      this.leftActions.childViewEventPrefix = 'button';
      this.actions.childViewEventPrefix = 'button';
      this.setupContent();
      this.listenToOnce(this, 'render', function () {
        this.activateStep(0);
      });
    },
    setupSteps: function setupSteps() {
      this.steps.ordered = true;
      this.steps.collection = new Backbone.Collection([{
        title: 'Upload',
        description: 'Select a CSV file',
        active: true
      }, {
        title: 'Validate',
        description: 'Preview results'
      }, {
        title: 'Submitted',
        description: 'Legacy data imported successfully'
      }]);
    },
    setupContent: function setupContent() {
      var btn = new UIKit.Button({
        text: 'Choose File'
      });
      this.fileInput.button = btn;
      this.fileInput.fluid = true;
      this.fileInput.readonly = true;
      this.fileInput.iconRight = true;
      this.createClearIconListeners();
      this.redoBtn.text = 'Import Another File';
      this.listenTo(this.redoBtn, 'press', function () {
        this.clearFileInput();
        this.activateStep(0);
      });
    },
    activateStep: function activateStep(stepIndex) {
      stepIndex = stepIndex || 0;
      this.$el.find('[data-step]').hide();
      this.$el.find('[data-step=' + stepIndex + ']').show();
      this.steps.activateAtIndex(stepIndex);
      this.updateActions(stepIndex);
    },
    createClearIconListeners: function createClearIconListeners() {
      var self = this;
      function removeFile() {
        self.clearFileInput();
        self.updateActions(0);
      }
      this.fileInput.$el.on('click', '.icon.remove', removeFile).on('keydown', '.icon.remove', function (ev) {
        if (ev.keyCode == 13) {
          removeFile();
        }
      });
    },
    clearFileInput: function clearFileInput() {
      this.fileInput.icon = null;
      this.fileInput.value = null;
      this.selectedItem = null;
    },
    onFileInputRender: function onFileInputRender(fileInput) {
      fileInput.$el.find('.icon.remove').prop('tabindex', 0);
    },
    onFileInputButtonPress: function onFileInputButtonPress() {
      this.triggerMethod('file:choose');
    },
    onLeftActionsButtonPress: function onLeftActionsButtonPress(container, btn) {
      this.onActionsButtonPress.apply(this, arguments);
    },
    onActionsButtonPress: function onActionsButtonPress(container, btn) {
      switch (btn.text) {
        case 'Next':
          this.triggerMethod('file:validate', this.selectedItem);
          break;
        case 'Previous':
          this.activateStep(0);
          break;
        case 'Submit':
          this.triggerMethod('file:submit', this.selectedItem);
          break;
      }
    },
    showResults: function showResults(data) {
      var results = this.results,
        cards = new Backbone.Collection();
      results.empty();
      function addNewCard(text, contentViewID, list, open) {
        var collection = _.map(list, function (d) {
            return {
              error: d
            };
          }),
          header = list.length + ' record' + (list.length == 1 ? ' ' : 's ') + text;
        cards.add({
          open: open,
          collection: new Backbone.Collection(collection),
          header: header,
          ariaTextSuffix: text,
          contentViewID: contentViewID
        });
      }
      addNewCard(langs.phrase('LegacuUpload.ResultsCard.Failed.Suffix'), 'failureResults', data.get('failure'), true);
      addNewCard(langs.phrase('LegacuUpload.ResultsCard.Updated.Suffix'), 'updateResults', data.get('update'), false);
      addNewCard(langs.phrase('LegacuUpload.ResultsCard.Updated.Suffix'), 'successResults', data.get('success'), false);
      results.add(new Mn.CollectionView({
        childView: ResultsCard,
        collection: cards
      }));
      this.numOfResults.text = data.get('failure').length + data.get('update').length + data.get('success').length + ' Records';
    },
    onFileValidated: function onFileValidated(results) {
      this.showResults(results);
      this.activateStep(1);
    },
    onFileImported: function onFileImported() {
      this.activateStep(2);
    },
    onFileSelected: function onFileSelected(file) {
      this.selectedItem = file;
      this.fileInput.icon = 'remove';
      this.fileInput.value = file.name;
      this.updateActions(0);
    },
    updateActions: function updateActions(currentStep) {
      var actionBtns = [],
        leftActionBtns = [],
        self = this;
      switch (currentStep) {
        case 0:
          var nextBtn = {
            text: 'Next',
            color: 'primary',
            ariaLabel: langs.phrase('LegacyUpload.NextButton.ARIALabel'),
            disabled: !this.selectedItem
          };
          actionBtns.push(nextBtn);
          break;
        case 1:
          leftActionBtns.push({
            text: 'Previous',
            ariaLabel: langs.phrase('LegacyUpload.PreviousButton.ARIALabel'),
            color: 'white'
          });
          actionBtns.push({
            text: 'Submit',
            color: 'primary'
          });
        case 2:
          var link = window.location.protocol + '//' + window.location.host + LEGACY_ROOT_URI + '/result';
          actionBtns.unshift({
            text: 'Export Results',
            color: 'white',
            link: link
          });
          break;
      }
      actionBtns = _.map(actionBtns, function (def) {
        return new UIKit.Button(def);
      });
      leftActionBtns = _.map(leftActionBtns, function (def) {
        return new UIKit.Button(def);
      });
      this.leftActions.empty();
      this.leftActions.addAll(leftActionBtns);
      this.actions.empty();
      this.actions.addAll(actionBtns);
    }
  });
  module.exports = LegacyUploadView;
});

